import { render, staticRenderFns } from "./FooterIcons.vue?vue&type=template&id=6720a32a&scoped=true&"
import script from "./FooterIcons.vue?vue&type=script&lang=js&"
export * from "./FooterIcons.vue?vue&type=script&lang=js&"
import style0 from "./FooterIcons.vue?vue&type=style&index=0&id=6720a32a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720a32a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseStoreIcons: require('/var/www/app/components/base/BaseStoreIcons.vue').default})
